import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
} from "@mui/material";

interface CustomSelectProps_updated {
  value: number | string | undefined;
  onChange: (event: any) => void;
  options: { label: string; value: string }[];
  error?: boolean;
  helperText?: string | false | undefined;
  placehoder: string | undefined;
  label?: string;
}

export default function CustomSelectUpdated({
  value = "",
  onChange,
  options = [],
  error,
  helperText,
  placehoder,
  label,
}: CustomSelectProps_updated) {
  return (
    <FormControl
      fullWidth
      variant="outlined"
      error={error}
      sx={{
        fontFamily: '"Lexend", sans-serif',
        "& .MuiOutlinedInput-root": {
          borderRadius: "8px",
          backgroundColor: "var(--neutral-50)",
          font: "var(--body-sm)",
          "& fieldset": {
            borderColor: "var(--neutral-200)",
          },
          "&:hover fieldset": {
            borderColor: "var(--neutral-300)",
          },
          "&.Mui-focused fieldset": {
            borderColor: "var(--neutral-400)",
          },
          "& .MuiSelect-select": {
            padding: "14px 12px",
          },
        },
        "& .MuiInputLabel-root": {
          font: "var(--body-sm)",
          color: "var(--neutral-600)",
          "&.Mui-focused": {
            color: "var(--neutral-700)",
          },
        },
        "& .MuiFormHelperText-root": {
          font: "var(--body-sm)",
          marginLeft: "4px",
        },
      }}
    >
      {label && <InputLabel>{label}</InputLabel>}
      <Select value={value} onChange={onChange} label={label} displayEmpty>
        {placehoder && (
          <MenuItem value="" disabled>
            {placehoder}
          </MenuItem>
        )}
        {Array.isArray(options) &&
          options.map((option, index) => (
            <MenuItem
              key={`option-${index}-${option?.value || index}`}
              value={option?.value || ""}
              sx={{
                font: "var(--body-sm)",
                padding: "8px 14px",
              }}
            >
              {option?.label || ""}
            </MenuItem>
          ))}
      </Select>
      {error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
